import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppstateService } from '../../services/appstate.service';
import { AuthServiceService } from '../../services/auth-service.service';

@Component({
  selector: 'app-navigation',
  imports: [RouterModule],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss'
})
export class NavigationComponent {
  isExpanded : boolean = false;
  user : any | null = null;

  constructor(private appstateService: AppstateService,private _service:AuthServiceService) {
    this.onChangeSidebar();
    this.user = this._service.getUserSession();
  }

  private onChangeSidebar(): void {
    this.appstateService.isAppSideBar.subscribe({
      next: (res: boolean) => {
        this.isExpanded = res;
      }
    })
  }

  signout(){
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("token");
  }
}
